import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Protocolo de Desintoxicación Digital',
    desc: 'El plan paso a paso para limpiar el exceso de dopamina digital en el cerebro de tu hijo. Incluye el Sistema SRS y el protocolo de 7 días para una transición sin drama.',
    bullets: ['Plan de acción días 1 al 7', 'Scripts exactos para hablar con tu hijo', 'Manejo de rabietas en tiempo real', 'Rutina nocturna de desconexión', 'Acuerdo familiar de pantallas']
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Libro de los Porqués',
    desc: 'Transformá su adicción a los videos en curiosidad científica real. Experimentos caseros clasificados por edad que reemplazan el estímulo digital con asombro genuino.',
    bullets: ['Exploradores (3-5 años)', 'Investigadores (6-8 años)', 'Científicos (9-12 años)', '13 experimentos con materiales de kiosco', 'Fichas, glosario y diploma']
  }, {
    icon: '📙',
    title: 'Tomo 3 — Desafíos Ninja',
    desc: '¡A descargar energía de verdad! Actividades de motricidad, equilibrio y coordinación para que terminen el día cansados, felices y lejos de la tablet.',
    bullets: ['Sistema de Energía Ninja (SEN)', 'Rojo: alta energía / Amarillo: media / Verde: calma', 'Circuitos físicos por edad', 'Desafíos de motricidad fina y gruesa']
  }, {
    icon: '📕',
    title: 'Tomo 4 — El Arte de Esperar',
    desc: 'El kit de emergencia para el consultorio, el auto y el restaurante. Actividades portátiles que funcionan cuando "no hay tiempo" y el celular siempre gana.',
    bullets: ['Actividades sin materiales', 'Juegos de palabras y atención', 'Fichas imprimibles de bolsillo', 'Técnicas de calma express']
  }, {
    icon: '📓',
    title: 'Tomo 5 — Conexión Profunda',
    desc: 'La guía para reconstruir el vínculo que las pantallas fueron erosionando. Juegos de conversación, rituales familiares y actividades de conexión emocional real.',
    bullets: ['Preguntas de conexión por edades', 'Juegos vinculares familiares', 'Rituales de inicio y cierre del día', 'Técnicas de escucha activa para padres']
  }, {
    icon: '📔',
    title: 'Tomo 6 — El Planificador Visual',
    desc: 'Tu centro de mando familiar. Rutinas visuales, cuadros de stickers, sistema de recompensas y el plan de 90 días para que el cambio sea permanente y sostenible.',
    bullets: ['Rutinas visuales listas para imprimir', 'Sistema de recompensas sin pantallas', 'Plan de 90 días semana a semana', 'Cuadros de seguimiento y logros']
  }];
  const features = ['Actividades listas para usar (sin preparación previa)', 'Clasificación por rango de edad', 'Materiales accesibles (kiosco o súper argentino)', 'Fichas imprimibles y reutilizables', 'Sin jerga psicológica — lenguaje directo para padres', 'Diseñado para la familia argentina real', '100% alineado al desarrollo infantil'];
  return <section className="bg-dark-900 py-20 px-4" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <div className="text-center mb-16" data-id="element-216">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-4" data-id="element-217">
            🏆 MEGAPACK NIÑOS SIN PANTALLAS™
          </h2>
          <p className="text-xl text-primary font-semibold mb-2" data-id="element-218">
            6 Tomos + 6 Bonos — De 2 a 12 años
          </p>
          <p className="text-lg text-cream/70" data-id="element-219">
            300+ páginas — Todo resuelto. Listo para usar hoy.
          </p>
        </div>

        <h3 className="text-2xl font-bold text-cream mb-8 flex items-center justify-center" data-id="element-220">
          📦 6 TOMOS COMPLETOS
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-221">
          {tomos.map((tomo, idx) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} key={idx} className="bg-dark-800 rounded-2xl p-8 border border-primary/20 hover:border-primary/50 transition-colors" data-id="element-222">
              <div className="flex items-start mb-4" data-id="element-223">
                <span className="text-4xl mr-4" data-id="element-224">{tomo.icon}</span>
                <h4 className="text-xl font-bold text-cream" data-id="element-225">{tomo.title}</h4>
              </div>
              <p className="text-cream/80 mb-6" data-id="element-226">{tomo.desc}</p>
              <div className="bg-dark-900 rounded-xl p-6" data-id="element-227">
                <p className="font-semibold text-primary mb-4" data-id="element-228">✅ Incluye:</p>
                <ul className="space-y-3" data-id="element-229">
                  {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start text-sm text-cream/90" data-id="element-230">
                      <CheckCircle2 className="w-5 h-5 text-primary mr-2 shrink-0" data-id="element-231" />
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary-dark rounded-3xl p-8 md:p-12 border border-primary/30" data-id="element-232">
          <h4 className="text-2xl font-bold text-cream mb-8 text-center" data-id="element-233">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-234">
            {features.map((feature, i) => <div key={i} className="flex items-center text-cream/90" data-id="element-235">
                <span className="text-cta mr-3 text-xl" data-id="element-236">✅</span>
                {feature}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}